// extracted by mini-css-extract-plugin
export default {"stroke":"IconDoor_stroke__BklwB","strokeAndFill":"IconDoor_strokeAndFill__b5Cqw"};